import { render, staticRenderFns } from "./home-swiper.vue?vue&type=template&id=0b7aa966"
import script from "./home-swiper.vue?vue&type=script&lang=js"
export * from "./home-swiper.vue?vue&type=script&lang=js"
import style0 from "./home-swiper.vue?vue&type=style&index=0&id=0b7aa966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports